import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main.scss';
import ReactGA from 'react-ga';

import config from 'config';

import lls from 'sources/localStorage/largeLocalStorage';
import locFunction from './locFunction';
import {JSXResolver} from './locFunction';

window.config = config;

if (config.gaKey) {
    ReactGA.initialize(config.gaKey);
    ReactGA.pageview(window.location.pathname + window.location.search);
}
window.loc = locFunction;
window.locJsxResolver = JSXResolver;

// Store Initialization
// ------------------------------------

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root');

let render = () => {
    const App = require('./components/App').default;

    ReactDOM.render(
      <App />, MOUNT_NODE,
    );
};

// Development Tools
// ------------------------------------
if (__DEV__) {
    if (module.hot) {
        const renderApp = render;
        const renderError = (error) => {
            const RedBox = require('redbox-react').default;

            ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
        };

        render = () => {
            try {
                renderApp();
            } catch (e) {
                console.trace(e);
                renderError(e);
            }
        };

        // Setup hot module replacement
        module.hot.accept([
            './components/App',
            './routes/index',
        ], () => setImmediate(() => {
            ReactDOM.unmountComponentAtNode(MOUNT_NODE);
            render();
        }));
    }
}

window.lls = lls;

// Let's Go!
// ------------------------------------
if (!__TEST__) render();



// WEBPACK FOOTER //
// ./src/main.js